import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProcessState } from '../_reducers/process.reducers';

const getProcessState =
  createFeatureSelector<ProcessState>('process');

export const getProcessLoading = createSelector(
  getProcessState,
  (state: ProcessState) => state.processLoading
);

export const getProcessesLoading = createSelector(
  getProcessState,
  (state: ProcessState) => state.processesLoading
);

/**
 * Select fields
 */
export const getProcesses = createSelector(
  getProcessState,
  (state: ProcessState) => state.processes
);


/**
 * Select operations
 */
export const getProcessOperations = createSelector(
  getProcessState,
  (state: ProcessState) => state.operations
);

/**
 * Select process
 */
export const getProcess = createSelector(
  getProcessState,
  (state: ProcessState) => state.process
);
/**
 * Select process
 */
export const getProcessStatus = createSelector(
  getProcessState,
  (state: ProcessState) => state.processDetails
);
/**
 * Select process
 */
export const getProcessRecordDetails = createSelector(
  getProcessState,
  (state: ProcessState) => state.processRecordDetails
);

/**
 * Select error
 */
export const getError = createSelector(
  getProcessState,
  (state: ProcessState) => state.error
);


/**
 * Select view process error
 */
export const viewProcessError = createSelector(
  getProcessState,
  (state: ProcessState) => state.viewProcessError
);

export const getNodeVerification = createSelector(
  getProcessState,
  (state:ProcessState) => state.verifyNode
)